import React from 'react'
import styled from 'styled-components'
import { Headline3, Subtitle2 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import AndroidReview from 'assets/for-parents/android-reviews.svg'
import IOSReview from 'assets/for-parents/ios-reviews.svg'
import { ReviewsNumbersSlice } from 'interfaces/GeneratedLandingPage'

const Container = styled.div<{ bottomColor?: string; topColor?: string }>`
    min-height: 120px;

    background-color: ${theme.colors.lightCaption} !important;
    position: relative;
    .top-bg {
        top: 0;
        position: absolute;
        height: 50%;
        width: 100%;

        background-color: ${theme.colors.deepSeaBlue};
    }
`

const Grid = styled.div`
    padding: 25px;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 25px;
    @media (max-width: 1050px) {
        flex-wrap: wrap;
    }
`

const Card = styled.div`
    width: 286px;
    height: 73px;
    background: ${theme.colors.white};
    border: 3px solid ${theme.colors.accentBlue};
    box-shadow: 4px 4px 0px ${theme.colors.accentBlue};
    border-radius: ${theme.borderRadius.normal};
    position: relative;
    svg {
        position: relative;
        bottom: 5px;
        padding: 5px;
        border-radius: inherit;
    }
    .middle {
        position: relative;
        bottom: 3px;
        height: inherit;
        width: inherit;
        display: flex;
        justify-content: space-evenly;
        gap: 0px;
        align-items: center;
        .texts {
            display: grid;
            gap: 5px;
        }
    }
`

interface Props {
    data: ReviewsNumbersSlice['primary']
}

const KnowunityNumbers = ({ data }: Props) => {
    return (
        <Container>
            <div className="top-bg" />
            <Grid>
                <Card>
                    <IOSReview />
                </Card>
                <Card>
                    <div className="middle">
                        <Headline3 color={theme.colors.accentBlue}>{data.title}</Headline3>
                        <div className="texts">
                            <Subtitle2 fontWeight={600} color={theme.colors.accentBlue}>
                                {data.top_text}
                            </Subtitle2>
                            <Subtitle2 fontWeight={600} color={theme.colors.accentBlue}>
                                {data.bottom_text}
                            </Subtitle2>
                        </div>
                    </div>
                </Card>
                <Card>
                    <AndroidReview />
                </Card>
            </Grid>
        </Container>
    )
}

export default KnowunityNumbers
